import { css } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";

export const commonStyles = {
    summaryDetailsList: (widthInPx: number, rowGap: string) =>
        css({
            display: "grid",
            marginBlock: 0,
            gridTemplateColumns: "max-content auto",
            rowGap: rowGap,
            columnGap: space[32],
            paddingTop: space[16],
            paddingBottom: space[16],
            "> dt": {
                gridColumn: 1,
                font: text.body.regular.medium,
                color: themeTokens.color.text.secondary,
                paddingLeft: 0,
                minWidth: `${widthInPx - 32}px`,
            },
            "> dd": {
                gridColumn: 2,
                font: text.body.regular.medium,
                color: themeTokens.color.text.primary,
                paddingRight: 0,
                marginInlineStart: 0, //resets this from the browser default
            },
        }),
};
